import { render, staticRenderFns } from "./CompTabelaExcecoes.vue?vue&type=template&id=2b3e97d2&"
import script from "./CompTabelaExcecoes.vue?vue&type=script&lang=js&"
export * from "./CompTabelaExcecoes.vue?vue&type=script&lang=js&"
import style0 from "./CompTabelaExcecoes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports